module.exports = __webpack_public_path__ + "d2738adcc867e5c842ba77c8740614bf.jpg";